
const translations = {
  // Navigation
  "nav.about": "会社概要",
  "nav.business": "事業内容",
  "nav.recruitment": "採用情報",
  "nav.contact": "お問い合わせ",

  // Hero Section
  "hero.title1": "高品質な繊維素材を",
  "hero.title2": "日本から世界に",
  "hero.subtitle1": "2006年創業、確かな品質と信頼で",
  "hero.subtitle2": "世界のブランドとダイレクトビジネス",
  "hero.cta": "事業内容を見る",

  // About Section
  "about.label": "About Us",
  "about.title": "会社概要",
  "about.description1": "株式会社セ・カンドは、2006年に設立された繊維素材の輸出を専門とする企業です。創業以来、高品質な製品とサービスの提供を通じて、海外のお客様との信頼関係を築いてまいりました。",
  "about.description2": "私たちは、繊維素材および糸製品を中心に、お客様とともに企画・開発を行い、100％海外輸出を実現しています。特にヨーロッパ圏、主にイタリアやフランスのブランドとのダイレクトビジネスを強みとしております。",
  "about.description3": "高品質かつ安定した供給体制を構築し、トレーサビリティおよび品質関連書類にも完全対応することで、お客様に安心してご利用いただける体制を整えております。",
  "about.companyName": "会社名",
  "about.companyNameValue": "株式会社セ・カンド",
  "about.englishName": "英語表記",
  "about.englishNameValue": "SECOND CO., LTD",
  "about.established": "設立",
  "about.establishedValue": "2006年11月17日",
  "about.representative": "代表者",
  "about.representativeValue": "代表取締役 野々垣ひろみ",
  "about.capital": "資本金",
  "about.capitalValue": "800万円",
  "about.employees": "従業員数",
  "about.employeesValue": "4名",
  "about.address": "所在地",
  "about.addressValue1": "愛知県一宮市大宮2-7-14",
  "about.addressValue2": "ノノガキビル２F",
  "about.phone": "電話番号",
  "about.phoneValue": "0586-25-4180",

  // Business Section
  "business.label": "Business",
  "business.title": "事業内容",
  "business.planning.title": "素材企画・販売",
  "business.planning.description": "各種糸・素材の企画から販売まで、お客様のニーズに合わせた提案を行います。ヨーロッパマーケットへの繊維素材の企画、プレゼン、販売を専門としています。",
  "business.export.title": "海外輸出業務",
  "business.export.description": "100%海外輸出、主にヨーロッパ圏（イタリア、フランス）への安定した供給体制を構築。ブランドとのダイレクトビジネスを実現しています。",
  "business.quality.title": "品質管理",
  "business.quality.description": "トレーサビリティおよび品質関連書類の完全対応。高品質な製品を安心してお届けするための徹底した品質管理体制を整えています。",

  // Recruitment Section
  "recruitment.label": "Recruitment",
  "recruitment.title": "採用情報",
  "recruitment.subtitle": "私たちと一緒に働きませんか",
  "recruitment.position": "輸出業務・貿易事務",
  "recruitment.jobTitle": "募集職種",
  "recruitment.jobTitleValue": "輸出業務、貿易事務",
  "recruitment.employmentType": "雇用形態",
  "recruitment.employmentTypeValue": "正社員、パート（どちらでもOK）",
  "recruitment.workingHours": "勤務時間",
  "recruitment.workingHoursValue": "10:00～18:00",
  "recruitment.location": "勤務地",
  "recruitment.locationValue": "愛知県一宮市大宮2-7-14 ノノガキビル２F",
  "recruitment.howToApply": "応募方法",
  "recruitment.howToApplyValue": "メールにてご連絡ください",
  "recruitment.atmosphere": "職場の雰囲気",
  "recruitment.atmosphere1": "女性が多く活躍している職場です",
  "recruitment.atmosphere2": "服装は自由（清潔感があればOK）",
  "recruitment.atmosphere3": "始業は午前10時でゆとりのある勤務時間",

  // Contact Section
  "contact.label": "Contact",
  "contact.title": "お問い合わせ",
  "contact.company": "会社名",
  "contact.name": "お名前",
  "contact.email": "メールアドレス",
  "contact.message": "お問い合わせ内容",
  "contact.submit": "送信する",
  "contact.submitting": "送信中...",
  "contact.success": "お問い合わせを受け付けました。ご連絡ありがとうございます。",
  "contact.error": "送信に失敗しました。もう一度お試しください。",
  "contact.characters": "文字",

  // Footer
  "footer.companyInfo": "会社情報",
  "footer.contact": "お問い合わせ",
  "footer.businessHours": "営業時間",
  "footer.weekday": "平日 10:00-18:00",
  "footer.holiday": "土日祝日休業",
  "footer.description": "株式会社セ・カンド\n高品質な繊維素材を\n世界へお届けします",
  "footer.copyright": "© 2006-2025 SECOND CO., LTD. All rights reserved."
};

export default translations;
